import { SidebarTrigger } from "@components/ui/sidebar";
import { Separator } from "@components/ui/separator";
import { Button } from "@components/ui/button";
import { Trans } from "@lingui/react/macro";
import { generatePath, Link } from "react-router-dom";
import { Organization } from "@/types/Organization";
import { PlusIcon } from "lucide-react";
import { ROUTES } from "@/routes_new";
import AccessControl from "@components/AccessControl";
import { postTrackingData } from "@/api/endpoints/track";

type HeaderProps = {
  orgUuid: Organization["uuid"];
};

export default function Header({ orgUuid }: HeaderProps) {
  return (
    <>
      <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
        <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6 max-w-7xl">
          <SidebarTrigger className="-ml-1" />
          <Separator
            orientation="vertical"
            className="mx-2 data-[orientation=vertical]:h-4"
          />
          <p>
            <Trans>Rapporter</Trans>
          </p>

          <AccessControl>
            <Button
              className="ml-auto"
              variant="outline"
              render={
                <Link
                  to={generatePath(ROUTES.REPORTS_NEW_ORGID, { orgUuid })}
                />
              }
              nativeButton={false}
              onClick={() => {
                postTrackingData("Click on new report template link", {
                  templateName: "blank",
                });
              }}
            >
              <Trans>Skapa blank rapport</Trans>
              <PlusIcon />
            </Button>
          </AccessControl>
        </div>
      </header>

      <div className="border-b">
        <div className="w-full p-4 lg:p-6 max-w-7xl flex flex-col gap-1">
          <h1 className="text-2xl font-bold">
            <Trans>Rapporter</Trans>
          </h1>
          <p className="text-sm text-muted-foreground">
            <Trans>
              Skapa en rapport med hjälp av en mall eller börja från grunden med
              en blank rapport.
            </Trans>
          </p>
        </div>
      </div>
    </>
  );
}
